var _defs, _rect, _text, _path, _text2, _polygon, _text3, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b,.c,.d,.e{fill:#fff;}.f{fill:#a6a6a6;}.c{font-size:13.96px;}.c,.g{font-family:BiomeW04-Bold, BiomeW04-Bold;}.g{fill:#4d4d4d;}.g,.d{font-size:8.38px;}.h{letter-spacing:.01em;}.d{font-family:BiomeW04-Regular, BiomeW04-Regular;}.e{opacity:.89;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 135,
    height: 40,
    rx: 5,
    ry: 5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "c",
    transform: "translate(51.04 40.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Apple Store"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M140,10.8c2.32,0,4.2,1.88,4.2,4.2v30c0,2.32-1.88,4.2-4.2,4.2H15c-2.32,0-4.2-1.88-4.2-4.2V15c0-2.32,1.88-4.2,4.2-4.2h125m0-.8H15c-2.75,0-5,2.25-5,5v30c0,2.75,2.25,5,5,5h125c2.75,0,5-2.25,5-5V15c0-2.75-2.25-5-5-5h0Z"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "d",
    transform: "translate(51.04 26.27)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "h",
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.02,
    y: 0
  }, "vailable on the"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "103.25 10 145 45.76 145 28.72 122.69 9.76 103.25 10"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "g",
    transform: "translate(118.81 17.89) rotate(41.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Soon!"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M41.35,24.65c-.16,.12-2.99,1.72-2.99,5.26,0,4.1,3.6,5.55,3.71,5.59-.02,.09-.57,1.99-1.9,3.92-1.18,1.7-2.42,3.4-4.3,3.4s-2.36-1.09-4.53-1.09-2.87,1.13-4.58,1.13-2.92-1.57-4.3-3.51c-1.6-2.27-2.89-5.8-2.89-9.15,0-5.37,3.49-8.22,6.93-8.22,1.83,0,3.35,1.2,4.5,1.2s2.79-1.27,4.87-1.27c.79,0,3.62,.07,5.48,2.74h0Zm-6.47-5.02c.86-1.02,1.47-2.43,1.47-3.85,0-.2-.02-.4-.05-.56-1.4,.05-3.06,.93-4.06,2.09-.79,.9-1.52,2.31-1.52,3.74,0,.22,.04,.43,.05,.5,.09,.02,.23,.04,.38,.04,1.25,0,2.83-.84,3.74-1.97h0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.290161ee49ba199fba7a5a4af216eaf1.svg";
export { ForwardRef as ReactComponent };